import { WebContext } from "@reboot-dev/reboot-web";
import { atom } from "jotai";

import { Logger } from "@moment/logging";

import { $accessTokenFunc } from "../authenication";
import { env } from "../env";
import { getRebootUrl } from "./utils/url";

let numTimesRebootContextCreated = 0;

const logger = new Logger("reboot-context");

/**
 * A single RebootContext for the entire application.
 *
 * IMPORTANT: DO NOT EVER MUTATE THIS ATOM! THIS IS A DATA LOSS RISK! The entire Reboot stack will
 * get re-created and any transactions that are in flight will be lost.
 */
export const $singletonRebootContext = atom((get): WebContext | null => {
	const rebootUrl = getRebootUrl(env.appEnv, env.isInIframe);
	if (!rebootUrl) {
		return null;
	}

	const { getAccessTokenSilently, traceId } = get($accessTokenFunc);
	if (!getAccessTokenSilently) {
		return null;
	}

	if (numTimesRebootContextCreated > 0) {
		const msg = `RebootContext should only be created once, created ${numTimesRebootContextCreated} times`;
		logger.error(msg);
	}
	numTimesRebootContextCreated++;

	logger.info(
		`[${traceId}] [AuthTokenAtom] Creating singleton RebootContext with getAccessTokenSilently function.`
	);

	return new WebContext({
		url: rebootUrl,
		bearerToken: getAccessTokenSilently,
		websockets: true,
	});
});
$singletonRebootContext.debugLabel = "rebootContext";
